import { render, staticRenderFns } from "./c-numerico.vue?vue&type=template&id=3b1e9516&scoped=true"
import script from "./c-numerico.vue?vue&type=script&lang=js"
export * from "./c-numerico.vue?vue&type=script&lang=js"
import style0 from "./c-numerico.vue?vue&type=style&index=0&id=3b1e9516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1e9516",
  null
  
)

export default component.exports